import { ChakraProvider, createLocalStorageManager } from "@chakra-ui/react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ErrorProvider } from "contexts";
// import { Provider } from "react-redux";
import store from "store";
// import SuccessProvider from "contexts/success.context";
import theme from "theme";

const manager = createLocalStorageManager("cachedTheme");

export default function Providers({ children }: any) {
  // const { actions } = useErrorStore();
  return (
    <ChakraProvider resetCSS theme={theme} colorModeManager={manager}>
      <BrowserRouter>
        <Provider store={store}>
          <ErrorProvider>{children}</ErrorProvider>
        </Provider>
      </BrowserRouter>
    </ChakraProvider>
  );
}
